import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { TrashBaseIcon } from '@tableau/icons/TrashBaseIcon';
import React from 'react';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { DraftBanner, DraftBannerAction } from '../../drafts/components/DraftBanner';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';
import { deleteFlowDraft } from '../actions/DeleteFlowDraftReduxAction';
import { editFlow } from '../actions/EditFlowReduxAction';

export type FlowDraftBannerProps = {
  readonly flow: ISpaceItemDetailInfo<'flow'>;
};

export function FlowDraftBanner(props: FlowDraftBannerProps): JSX.Element {
  if (!props.flow || !props.flow.flowDraft) {
    return null;
  }

  const handleEditFlow = () => {
    if (props?.flow) {
      getAppStore().dispatch(editFlow(props.flow));
    }
  };

  const handleDeleteDraft = () => {
    if (props?.flow) {
      getAppStore().dispatch(deleteFlowDraft([props.flow]));
    }
  };

  const getContinueEditBannerAction: () => DraftBannerAction = () => ({
    label: Messages.continueEditing(),
    handleAction: handleEditFlow,
    icon: <PencilBaseIcon size={18} aria-hidden={true}/>,
    testId: 'continue-editing'
  });

  const getDeleteDraftBannerAction: () => DraftBannerAction = () => ({
    label: Messages.deleteDraft(),
    handleAction: handleDeleteDraft,
    icon: <TrashBaseIcon size={14} aria-hidden={true}/>,
    testId: 'delete-draft'
  });

  return (
    <DraftBanner
      lastEditDate={props.flow.flowDraft.lastUpdatedAt}
      draftBannerActions={[getContinueEditBannerAction(), getDeleteDraftBannerAction()]}
      contentTypeName={Messages.lastEditedFlow()}
    />
  );
}
